import { showErrorAlert } from 'utils/AlertUtils';
import {
  failureBulkUpload,
  requestBulkUpload,
  responseBulkUpload,
} from '../../slices/merchantSlice/merchantSlice';
import {
  MERCHANT_BULK_UPLOAD,
  MERCHANT_BULK_UPLOAD_TEMPLATE,
} from '../../../utils/StaticApiEndpoints';
import requestApi from 'utils/Request';

export const BulkUploadMerchants = (file, onSuccess) => async (dispatch) => {
  try {
    dispatch(requestBulkUpload());
    const formData = new FormData();
    formData.append('file', file);
    const res = await requestApi.post(MERCHANT_BULK_UPLOAD, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    dispatch(responseBulkUpload(res));
    if (typeof onSuccess === 'function') {
      onSuccess();
    }
  } catch (error) {
    dispatch(failureBulkUpload(error?.message));
    showErrorAlert(error?.message || 'Upload failed. Please try again.');
  }
};

export const DownloadBulkUploadTemplate = () => async () => {
  try {
    const res = await requestApi.get(MERCHANT_BULK_UPLOAD_TEMPLATE, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([res?.data ?? res]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'merchant-bulk-upload-template.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (_error) {
    // silent — template download failure is non-critical
  }
};
